import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import supabase from '../supabaseClient';
import { LogoSVG } from './ui/FormControls';

// ── REGISTRO PÚBLICO — PLAN FREE ────────────────────────────────
export const RegistroFreeScreen = () => {
  const navigate = useNavigate();
  const [nombre, setNombre] = useState("");
  const [email, setEmail] = useState("");
  const [empresa, setEmpresa] = useState("");
  const [password, setPassword] = useState("");
  const [confirmar, setConfirmar] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [enviado, setEnviado] = useState(false);

  const registrar = async () => {
    setError("");
    if (!nombre.trim() || !email.trim() || !empresa.trim() || !password) {
      setError("Rellena todos los campos.");
      return;
    }
    if (password.length < 6) {
      setError("La contraseña debe tener al menos 6 caracteres.");
      return;
    }
    if (password !== confirmar) {
      setError("Las contraseñas no coinciden.");
      return;
    }
    setLoading(true);
    const { error: signUpError } = await supabase.auth.signUp({
      email: email.trim().toLowerCase(),
      password,
      options: { data: { nombre: nombre.trim(), nombre_empresa: empresa.trim() } },
    });
    setLoading(false);
    if (signUpError) {
      setError(signUpError.message === "User already registered" ? "Ya existe una cuenta con ese email." : "Error al crear la cuenta. Inténtalo de nuevo.");
      return;
    }
    setEnviado(true);
  };

  if (enviado) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-8 text-center space-y-3">
          <div className="w-14 h-14 rounded-2xl mx-auto flex items-center justify-center" style={{ background: "linear-gradient(145deg,#0ea5e9,#0369a1)" }}>
            <LogoSVG size={32} />
          </div>
          <h2 className="text-xl font-black text-gray-800">Revisa tu email</h2>
          <p className="text-sm text-gray-500">Te hemos enviado un enlace de confirmación a <strong>{email}</strong>. Ábrelo para activar tu cuenta gratuita.</p>
          <button onClick={() => navigate("/")} className="text-xs text-gray-400 hover:text-gray-600 pt-2">← Volver al inicio</button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 py-10">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-8 space-y-4">
        <div className="text-center">
          <div className="w-14 h-14 rounded-2xl mx-auto mb-3 flex items-center justify-center" style={{ background: "linear-gradient(145deg,#0ea5e9,#0369a1)" }}>
            <LogoSVG size={32} />
          </div>
          <h1 className="text-xl font-black text-gray-800">Ware<span className="text-sky-500">Hause</span><span className="text-green-500">Plan</span></h1>
          <p className="text-xs text-gray-400 mt-1">Crea tu cuenta gratuita</p>
        </div>

        <div>
          <label className="text-xs font-semibold text-gray-600 uppercase">Nombre</label>
          <input className="w-full border rounded-lg px-3 py-2 text-sm mt-1 focus:outline-none focus:ring-2 focus:ring-blue-400" value={nombre} onChange={e => setNombre(e.target.value)} placeholder="Tu nombre" />
        </div>
        <div>
          <label className="text-xs font-semibold text-gray-600 uppercase">Email</label>
          <input type="email" className="w-full border rounded-lg px-3 py-2 text-sm mt-1 focus:outline-none focus:ring-2 focus:ring-blue-400" value={email} onChange={e => setEmail(e.target.value)} placeholder="tu@email.com" />
        </div>
        <div>
          <label className="text-xs font-semibold text-gray-600 uppercase">Nombre de empresa</label>
          <input className="w-full border rounded-lg px-3 py-2 text-sm mt-1 focus:outline-none focus:ring-2 focus:ring-blue-400" value={empresa} onChange={e => setEmpresa(e.target.value)} placeholder="Nombre de tu empresa" />
        </div>
        <div>
          <label className="text-xs font-semibold text-gray-600 uppercase">Contraseña</label>
          <input type="password" className="w-full border rounded-lg px-3 py-2 text-sm mt-1 focus:outline-none focus:ring-2 focus:ring-blue-400" value={password} onChange={e => setPassword(e.target.value)} placeholder="Mínimo 6 caracteres" onKeyDown={e => e.key === "Enter" && registrar()} />
        </div>
        <div>
          <label className="text-xs font-semibold text-gray-600 uppercase">Confirmar contraseña</label>
          <input type="password" className="w-full border rounded-lg px-3 py-2 text-sm mt-1 focus:outline-none focus:ring-2 focus:ring-blue-400" value={confirmar} onChange={e => setConfirmar(e.target.value)} placeholder="Repite la contraseña" onKeyDown={e => e.key === "Enter" && registrar()} />
        </div>

        {error && <p className="text-xs text-red-600 font-semibold text-center">{error}</p>}

        <button onClick={registrar} disabled={loading} className="w-full bg-blue-600 text-white font-bold py-3 rounded-xl hover:bg-blue-700 disabled:opacity-40 transition-all">
          {loading ? "Creando cuenta..." : "Crear cuenta gratis →"}
        </button>
        <button onClick={() => navigate("/")} className="w-full text-xs text-gray-400 hover:text-gray-600">← Volver al inicio</button>
      </div>
    </div>
  );
};
